import React, { useEffect, useState } from "react";
import { Table } from "antd";
import Header from "../../../../Components/Header/Header";
import ButtonActions from "../../../../Components/Buttons/ButtonActions/ButtonActions";
import Spinner from "../../../../Components/Spinner";
import ModalMergeActivities from "./ModalMergeActivities/ModalMergeActivities";
import { useSyncActions } from "./useSyncActions";
import { buildSyncDataSource, buildMergePayload } from "./utils";
import { getSyncColumns } from "./columns";
import classes from "./SyncActivities.module.scss";

const SyncActivities = () => {
  const { syncData, isLoading, getSyncData, mergeSelected } =
    useSyncActions();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [mergeModalOpen, setMergeModalOpen] = useState(false);

  useEffect(() => {
    getSyncData();
  }, [getSyncData]);

  const dataSource = buildSyncDataSource(syncData);

  const toggleExpandedRow = (rowKey) =>
    setExpandedRowKeys((prev) =>
      prev.includes(rowKey)
        ? prev.filter((key) => key !== rowKey)
        : [...prev, rowKey]
    );

  const columns = getSyncColumns({
    expandedRowKeys,
    onToggleExpand: toggleExpandedRow,
  });

  const mergePayload = buildMergePayload(syncData, selectedRowKeys);

  return (
    <div className={classes.SyncActivitiesList}>
      <div className={classes.SyncActivitiesHeader}>
        <Header text="Sincronizar Atividades" />

        <ButtonActions
          variant="primary"
          text="Mergear selecionados"
          disabled={selectedRowKeys.length === 0}
          onClick={() => setMergeModalOpen(true)}
        />
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <Table
          columns={columns}
          dataSource={dataSource}
          rowKey="rowKey"
          rowSelection={{
            type: "checkbox",
            selectedRowKeys,
            onChange: setSelectedRowKeys,
          }}
          pagination={false}
        />
      )}

      <ModalMergeActivities
        open={mergeModalOpen}
        onCancel={() => setMergeModalOpen(false)}
        payload={mergePayload}
        onMerge={mergeSelected}
      />
    </div>
  );
};

export default SyncActivities;
